import { Spinner, HStack, Text } from '@chakra-ui/react'
import { useMemo } from 'react'
import {
  FaCheckCircle,
  FaExclamationCircle,
  FaQuestionCircle,
} from 'react-icons/fa'

type Status = 'waiting' | 'building' | 'starting' | 'done' | 'failed' | string

const DeploymentStatus = (status: Status) => {
  const { text, icon, spinner } = useMemo(() => {
    //@ts-ignore
    switch (status?.status) {
      case 'done':
        return {
          text: 'Deployed',
          icon: (
            <span>
              <FaCheckCircle
                style={{ width: '1.5rem', height: '1.5rem' }}
                color="#48BB78"
              />
            </span>
          ),
        }
      case 'failed':
        return {
          text: 'Deployment failed',
          icon: (
            <span>
              <FaExclamationCircle
                style={{ width: '1.5rem', height: '1.5rem' }}
                color="#F56565"
              />
            </span>
          ),
        }
      case 'waiting':
        return {
          text: 'Deployment in queue',
          spinner: <Spinner w="1.5rem" h="1.5rem" color="gray.300" />,
        }
      case 'building':
        return {
          text: 'Building app',
          spinner: <Spinner w="1.5rem" h="1.5rem" color="#ED8936" />,
        }
      case 'starting':
        return {
          text: 'Starting app',
          spinner: <Spinner w="1.5rem" h="1.5rem" color="green.400" />,
        }
      default:
        return {
          text: 'N/A',
          icon: (
            <span>
              <FaQuestionCircle style={{ width: '1.5rem', height: '1.5rem' }} />
            </span>
          ),
        }
    }
  }, [status])

  return (
    <HStack alignItems="center">
      {icon ? icon : spinner}
      <Text>{text}</Text>
    </HStack>
  )
}

export default DeploymentStatus
